import React, { useEffect } from "react";
import { CharacterSheet } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const ValoresDerivados: React.FC<Props> = ({ character, onChange }) => {
  // Calcular valores derivados automaticamente
  useEffect(() => {
    const CON = character.atributos.CON.nivel;
    const POD = character.atributos.POD.nivel;
    const pvMaximos = CON * 6;
    const pqMaximos = POD * 10 + CON;

    if (
      character.valoresDerivados.pvMaximos !== pvMaximos ||
      character.valoresDerivados.pqMaximos !== pqMaximos
    ) {
      onChange({
        ...character,
        valoresDerivados: {
          ...character.valoresDerivados,
          pvMaximos,
          pqMaximos,
          pvAtuais: Math.min(character.valoresDerivados.pvAtuais, pvMaximos),
          pqAtuais: Math.min(character.valoresDerivados.pqAtuais, pqMaximos),
        },
      });
    }
  }, [character.atributos.CON.nivel, character.atributos.POD.nivel]);

  const updateValor = (field: keyof CharacterSheet["valoresDerivados"], value: number) => {
    onChange({
      ...character,
      valoresDerivados: {
        ...character.valoresDerivados,
        [field]: value,
      },
    });
  };

  return (
    <div className="section">
      <h2>Valores Derivados</h2>
      <div className="form-grid">
        <div className="form-group">
          <label>PV Máximos (CON × 6)</label>
          <input
            type="number"
            value={character.valoresDerivados.pvMaximos}
            readOnly
            className="readonly"
          />
        </div>
        <div className="form-group">
          <label>PV Atuais</label>
          <input
            type="number"
            value={character.valoresDerivados.pvAtuais}
            onChange={(e) => updateValor("pvAtuais", parseInt(e.target.value) || 0)}
            min="0"
            max={character.valoresDerivados.pvMaximos}
          />
        </div>
        <div className="form-group">
          <label>PQ Máximos ((POD × 10) + CON)</label>
          <input
            type="number"
            value={character.valoresDerivados.pqMaximos}
            readOnly
            className="readonly"
          />
        </div>
        <div className="form-group">
          <label>PQ Atuais</label>
          <input
            type="number"
            value={character.valoresDerivados.pqAtuais}
            onChange={(e) => updateValor("pqAtuais", parseInt(e.target.value) || 0)}
            min="0"
            max={character.valoresDerivados.pqMaximos}
          />
        </div>
      </div>
    </div>
  );
};
